import woothee from 'woothee';

function getUa () {
  const ua = woothee.parse(window.navigator.userAgent);
  ua.version_float = getVersionFloat(ua.version);
  ua.version_int = getVersionInt(ua.version);
  ua.os_version_float = getVersionFloat(ua.os_version);
  ua.os_version_int = getVersionInt(ua.os_version);
  return ua;
};

function isAndroidDefault () {
  return getUa().name == 'Safari' && getUa().os == 'Android';
};

function isAndroidSupport(ver) {
  return getUa().os === 'Android' && getUa().os_version_float > ver;
};

function isIOSSupport(ver) {
  return (getUa().os == 'iPhone' || getUa().os == 'iPad' || getUa().os == 'iPod') && getUa().os_version_float >= ver;
};

function isIESupport(ver) {
  return getUa().name === 'Internet Explorer' && getUa().version_float >= ver;
};

function isPC() {
  return getUa().category === 'pc' && getUa().name !== 'Internet Explorer';
};

function getVersionFloat(ver){
  const version_ary = ver.split('.');
  const version_int = parseInt(version_ary.shift(),10);
  return parseFloat(version_int +'.'+ version_ary.join(''));
}

function getVersionInt(ver){
  const version_ary = ver.split('.');
  return parseInt(version_ary.shift(),10);
}


export {isPC, isIESupport, isAndroidSupport, isAndroidDefault, isIOSSupport, getUa};



// WEBPACK FOOTER //
// ./source/javascripts/utils/device.js